import { computed } from 'vue';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import router from '@/common/router';
import { usePaSearchSectionStore } from '@/common/stores/slide-detail';
import { MenuInfo } from '../types';
import { BASE_MENU_VALUE } from '../baseMenu.define';

export interface Props {
  menuInfo: MenuInfo;
  selected?: boolean;
}

export const setup = (props: Props) => {
  const { selectSubPanelMenu } = useBaseMenuStore();
  const { openSearchSection } = usePaSearchSectionStore();
  const computedChildrenLength = computed(() => props.menuInfo.subMenuList?.length ?? 0);

  const isChildMenuAvailable = computed(() => {
    if (props.menuInfo.value === BASE_MENU_VALUE.DASHBOARD) return true;
    return !!props.menuInfo.subMenuList && props.menuInfo.subMenuList.length;
  });

  const onClickElement = async () => {
    const shouldSelect = !props.menuInfo.meta?.noMenuSelect;

    if (!props.menuInfo.path) {
      if (shouldSelect) selectSubPanelMenu(props.menuInfo.value);
      return;
    }

    if (shouldSelect) {
      selectSubPanelMenu(props.menuInfo.value);
    }

    // PA 섹션 메뉴 클릭 시, 좌측 검색 슬라이드 열림
    if (props.menuInfo.meta?.category === BASE_MENU_VALUE.PA && props.selected) {
      openSearchSection();
      return;
    }

    router.push(props.menuInfo.path);
  };

  return { computedChildrenLength, isChildMenuAvailable, onClickElement };
};
